// Version 2 price ranges reserve a value beyond every supported currency scale.
export const UNBOUNDED_PRICE = Number.MAX_SAFE_INTEGER;
